// extracted by mini-css-extract-plugin
module.exports = {"color":"PatientAppointment_color__1lPph","parrafo":"PatientAppointment_parrafo__1TjNK","subTitle":"PatientAppointment_subTitle__optl7","scroll":"PatientAppointment_scroll__1VK01"};